import React from 'react';
import $image_url from 'js/utils/image_url';
import truncateWorkTitle from './truncate_work_title';

interface ThisPaperDescriptionProps {
  workTitle: string;
}

export function ThisPaperDescription(props: ThisPaperDescriptionProps) {
  const { workTitle } = props;

  return (
    <div className="all-products-modal-product-container">
      <div className="all-products-modal-product-icon-container">
        <div className="all-products-modal-product-paper-container">
          <img src={$image_url('blank-paper.png')} style={{ width: '80px' }} />
          <div className="all-products-modal-paper-icon-label-container">
            <div className="all-products-modal-paper-icon-label-inner-container">
              <div className="all-products-modal-paper-icon-label">PDF</div>
              <div className="all-products-modal-paper-icon-label-triangle"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="all-products-modal-product-features-container">
        <h3 className="all-products-modal-product-features-heading">
          This paper
        </h3>
        <div className="all-products-modal-product-feature">
          <div className="all-products-modal-product-checkmark">
            <i className="fa fa-check" />
          </div>
          <div>
            [PDF] “
            <span className="paper-title">{truncateWorkTitle(workTitle)}</span>”
          </div>
        </div>
      </div>
    </div>
  );
}
